export default __webpack_public_path__ + "fa96666865e9e84249733f3503044be3.svg";